export const statusField = 'status';
export const eventField = 'event';
export const eventIdField = 'eventId';
export const idField = 'id';
export const finishedStatus = 'finished';
export const pendingStatus = 'pending';

